import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { DeactivateUserInput, DeactivateUserMutation } from '@/gql/graphql';

const DEACTIVATE_USER_MUTATION = graphql(`
  mutation DeactivateUser($input: DeactivateUserInput!) {
    deactivateUser(input: $input) {
      id
      status
    }
  }
`);

const useDeactivateUser = (
  options?: UseMutationOptions<
    DeactivateUserMutation,
    unknown,
    DeactivateUserInput
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(DEACTIVATE_USER_MUTATION, { input });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountUsers(),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useDeactivateUser;
